export const ADD_LOCATION_CRITERIA_REQUEST = 'ADD_LOCATION_CRITERIA_REQUEST';
export const ADD_LOCATION_CRITERIA_SUCCESS = 'ADD_LOCATION_CRITERIA_SUCCESS';
export const ADD_LOCATION_CRITERIA_FAILURE = 'ADD_LOCATION_CRITERIA_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_location_create/redux/constants/add_location_criteria.constants.js